import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2
} from '@angular/core'
import { DndDropEvent } from 'ngx-drag-drop'

import { appConstants } from '../../../app.constants'
import { Incentive } from '../../../shared/interfaces/resources/incentive.interface'

@Component({
  selector: 'app-order-incentives-modal',
  templateUrl: './order-incentives-modal.component.html',
  styleUrls: ['./order-incentives-modal.component.scss']
})
export class OrderIncentivesModalComponent implements OnChanges {
  @Input() incentives: Incentive[]
  @Output() onCloseModal: EventEmitter<string[]> = new EventEmitter()

  constructor(private renderer: Renderer2) {}

  ngOnChanges(): void {
    if (this.incentives?.length) {
      this.incentives = this.incentives.filter(
        (incentive) =>
          incentive.id !== appConstants.incentives.OECDmedianId &&
          incentive.id !== appConstants.incentives.EUmedianId
      )
    }

    this.renderer.addClass(document.querySelector('html'), 'is-clipped')
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.querySelector('html'), 'is-clipped')
  }

  onDrag(item: Incentive) {
    const index = this.incentives.indexOf(item)
    this.incentives.splice(index, 1)
  }

  onDrop(event: DndDropEvent) {
    let index = event.index
    if (typeof index === 'undefined') {
      index = this.incentives.length
    }

    this.incentives.splice(index, 0, event.data)
  }

  close(saveChanges: boolean) {
    if (saveChanges) {
      this.onCloseModal.emit(this.incentives.map((incentive) => incentive.id))
    } else {
      this.onCloseModal.emit()
    }
  }
}
